













import Vue from 'vue'
import LazyLoad from 'vanilla-lazyload'
import { TARGET_SELECTOR, THRESHOLD, LOADED_SELECTOR } from '@/common/constants'
import { getImageSrcset } from '../utils/common'
import { captureException } from '@sentry/browser'

export default Vue.extend({
  props: {
    isLazy: {
      type: Boolean,
      default: true
    },
    showPlaceholder: {
      type: Boolean,
      default: true
    },
    showLoader: {
      type: Boolean,
      default: false
    },
    variantName: {
      type: String,
      default: ''
    }
  },
  computed: {
    dataSrcset(): string {
      if (this.variantName) {
        const src = this.$attrs['data-src']
        return getImageSrcset(src, this.variantName)
      }
      return ''
    }
  },
  updated(): void {
    if (this.isLazy) this.runLazyLoad()
  },
  mounted(): void {
    if (this.isLazy) this.runLazyLoad()
    if (!this.$attrs['data-src'] && !this.$attrs['src']) {
      console.error('Missing image src: ', this.$attrs)
      captureException(new Error('Missing image src'))
    }
  },
  methods: {
    runLazyLoad() {
      if (!window.lazyLoadInstance)
        window.lazyLoadInstance = new LazyLoad({
          elements_selector: TARGET_SELECTOR,
          threshold: THRESHOLD,
          class_loaded: LOADED_SELECTOR
        })
      window.lazyLoadInstance.update()
    },
    onError() {
      if (window.location.href.includes('/cart')) {
        console.error('Load image failed', this.$attrs['data-src'])
        captureException(new Error('Load image failed'))
      }
    }
  }
})
